// src/theme.js
import { extendTheme } from '@chakra-ui/react';

// Replace these with your actual brand color codes
const colors = {
  brand: {
    50: "#7495b6", // Example light shade
    100: "#7495b6",
    200: "#7495b6",
    300: "#7495b6",
    400: "#7495b6",
    500: "#183444", // Your primary brand color
    600: "#183444",
    700: "#183444",
    800: "#183444",
    900: "#183444", // Example dark shade
  },
  // You can define other color palettes here, e.g., secondary, accent
  accent: {
      500: "#183444", // Example accent color
  }
};

const theme = extendTheme({ colors });

export default theme;
